import { InjectionToken } from '@angular/core';

import { environment } from '../../../environments/environment';

export const CONFIG_URL = new InjectionToken<string>('CONFIG_URL', {
    providedIn: 'root',
    factory: () => environment.configUrl,
});

export const BASE_URL = new InjectionToken<Promise<string>>('BASE_URL');
export const API_KEY = new InjectionToken<Promise<string>>('API_KEY');
export const RECAPTCHA_SITE_KEY = new InjectionToken<Promise<string>>('RECAPTCHA_SITE_KEY');
export const RECAPTCHA_HEADER = new InjectionToken<Promise<string>>('RECAPTCHA_HEADER');
export const RECAPTCHA_API_URL = new InjectionToken<Promise<string>>('RECAPTCHA_API_URL');

export const APP_VERSION = new InjectionToken<string>('APP_VERSION', {
    providedIn: 'root',
    factory: () => environment.appVersion,
});

export const IS_PRODUCTION = environment.production;
